// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36b89","label":"styles_label__3mDaY"};